import React, { useState } from "react";
import "../../components/CityList/CityList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Loader from "../../components/Loader/loader";

const CityList = ({
  cityDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  setOpenAddProfile,
  setFilterCityData,
  loading,
}) => {

  const itemsPerPage = 50; // Set number of items per page
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = cityDetailResponse?.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  function HandleChange(param) {
    GetId(param);
  }
  //console.log(cityDetailResponse);
  return (
    <div className="container-fluid">
      <div className="cityList">
        <table>
          <thead>
            <tr className="cityListHeading">
              <th>S No.</th>
              <th>Country Name</th>
              <th>State Name</th>
              <th>City Name</th>
              <th>Action</th>
            </tr>
          </thead>
          {loading ? (
            <div style={{ position: "relative", left: "540px" }}>
              <Loader />
            </div>
          ) : (
            <tbody>
              { paginatedData?.length > 0 ? (
                paginatedData.map((city) => (
                  <tr key={city.id}>
                    <td>{city.id}</td>
                    <td>{city.countryname}</td>
                    <td>{city.stateName}</td>
                    <td>{city.name ? city.name : city.cityName}</td>
                    <td>
                      <button
                        style={{
                          height: "35px",
                          width: "35px",
                          backgroundColor: "#F1F1F1",
                        }}
                        onClick={() => {
                          setOpenProfile(!openProfile);
                          HandleChange(city.id);
                          setOpenAddProfile(false);
                          setFilterCityData(false);
                        }}
                      >
                        <EditOutlinedIcon className="icon" />
                      </button>
                      <button
                        style={{
                          height: "35px",
                          width: "35px",
                          marginLeft: "5px",
                          backgroundColor: "#F4616F",
                          borderColor: "#FF0000",
                        }}
                      >
                        <DeleteOutlinedIcon className="icon" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <p>empty</p>
              )}
            </tbody>
          )}
        </table>
        <nav
          aria-label="Page navigation"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <ul className="pagination">
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {currentPage - 1}
              </a>
            </li>
            <li className="page-item active">
              <a className="page-link">{currentPage}</a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= cityDetailResponse?.length}
              >
                {currentPage + 1}
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={endIndex >= cityDetailResponse?.length}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default CityList;
